"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentSignatureHookEventDto = exports.DocumentSignatureEventTopics = exports.PacketStatusEnum = void 0;
const zod_1 = require("zod");
var PacketStatusEnum;
(function (PacketStatusEnum) {
    PacketStatusEnum["PENDING"] = "PENDING";
    PacketStatusEnum["PENDING_SIGNATURE"] = "PENDING_SIGNATURE";
    PacketStatusEnum["FAILED"] = "FAILED";
    PacketStatusEnum["CANCELED"] = "CANCELED";
    PacketStatusEnum["SIGNED"] = "SIGNED";
})(PacketStatusEnum = exports.PacketStatusEnum || (exports.PacketStatusEnum = {}));
var DocumentSignatureEventTopics;
(function (DocumentSignatureEventTopics) {
    DocumentSignatureEventTopics["DOCUMENT_PREPARE_DATA"] = "document.signature.prepare.data";
    DocumentSignatureEventTopics["DOCUMENT_SIGNATURE_EVENTS"] = "document.signature.events";
})(DocumentSignatureEventTopics = exports.DocumentSignatureEventTopics || (exports.DocumentSignatureEventTopics = {}));
exports.documentSignatureHookEventDto = zod_1.z.object({
    id: zod_1.z.string().min(1),
    new_status: zod_1.z.nativeEnum(PacketStatusEnum),
    old_status: zod_1.z.nativeEnum(PacketStatusEnum),
});
